import React, { useState, useEffect } from "react";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import Shell from "./Shell";
import { useAdminStyles, num, dateTime } from "./styles";

// Saúde da operação: está tudo rodando? o que falha, para quem, desde quando?
const Operations = () => {
  const classes = useAdminStyles();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/operations").then(r => setD(r.data)).catch(toastError);
  }, []);

  if (!d) return <Shell title="Operação"><div className={classes.empty}>Carregando…</div></Shell>;

  const { dias, errosComuns, webhooks, api: apiStats, sms, agenda, filas } = d;
  const maxRuns = dias.reduce((m, x) => Math.max(m, x.runs), 0) || 1;
  const hoje = dias.length ? dias[dias.length - 1] : { runs: 0, erros: 0 };
  const filaPresa = filas.some(f => f.erro || (f.failed || 0) > 0);

  return (
    <Shell title="Operação">
      <div className={classes.cards}>
        <div className={classes.kpi}>
          <div className={classes.kpiLabel}>Execuções hoje</div>
          <div className={classes.kpiValue}>{num(hoje.runs)}</div>
          <div className={classes.kpiHint}>{num(hoje.erros)} com erro</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiLabel}>Webhooks (24h)</div>
          <div className={classes.kpiValue}>{num(webhooks.total24)}</div>
          <div className={classes.kpiHint}>{num(webhooks.falhas24)} falha(s)</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiLabel}>API (7d)</div>
          <div className={classes.kpiValue}>{num(apiStats.total)}</div>
          <div className={classes.kpiHint}>{apiStats.latenciaMedia}ms em média · {num(apiStats.erros5xx)} erro(s) 5xx</div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpiLabel}>Agendamentos</div>
          <div className={classes.kpiValue}>{num(agenda.ativos)}</div>
          <div className={classes.kpiHint}>
            {agenda.atrasados ? `${num(agenda.atrasados)} atrasado(s) — scheduler?` : "nenhum atrasado"}
          </div>
        </div>
      </div>

      <div className={classes.card}>
        <div className={classes.cardTitle}>Filas</div>
        <div className={classes.cardSub}>
          Lidas ao vivo no Redis. {filaPresa ? "Há job com falha ou fila ilegível." : "Sem jobs falhos."}
        </div>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <thead>
              <tr>
                {["Fila", "Aguardando", "Ativos", "Agendados", "Falhos", "Pausados"].map((h, i) => (
                  <th key={h} className={`${classes.th} ${classes.thPlain}`} style={i ? { textAlign: "right" } : undefined}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filas.map(f => (
                <tr key={f.nome}>
                  <td className={classes.td}><div className={classes.strong}>{f.nome}</div></td>
                  {f.erro ? (
                    <td className={classes.td} colSpan={5}>
                      <span className={`${classes.pill} ${classes.bad}`}>ilegível</span>{" "}
                      <span className={classes.muted}>{f.erro}</span>
                    </td>
                  ) : (
                    <>
                      <td className={`${classes.td} ${classes.tdNum}`}>{num(f.waiting)}</td>
                      <td className={`${classes.td} ${classes.tdNum}`}>{num(f.active)}</td>
                      <td className={`${classes.td} ${classes.tdNum}`}>{num(f.delayed)}</td>
                      <td className={`${classes.td} ${classes.tdNum}`}>
                        {f.failed ? <span className={`${classes.pill} ${classes.bad}`}>{num(f.failed)}</span> : "—"}
                      </td>
                      <td className={`${classes.td} ${classes.tdNum}`}>{num(f.paused)}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={classes.card}>
        <div className={classes.cardTitle}>Execuções por dia (14 dias)</div>
        <div className={classes.cardSub}>A parte escura é o que terminou em erro.</div>
        {dias.length === 0 && <div className={classes.empty}>Nenhuma execução no período.</div>}
        {dias.map((x, i) => (
          <div key={x.dia} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
            <div style={{ width: 86 }} className={classes.strong}>{String(x.dia).slice(0, 10).split("-").reverse().slice(0, 2).join("/")}</div>
            <div className={classes.grow}>
              <div className={classes.bar} style={{ display: "flex" }}>
                <div className={classes.barFill} style={{ width: `${((x.runs - x.erros) / maxRuns) * 100}%`, borderRadius: 0, opacity: 0.35 }} />
                <div className={classes.barFill} style={{ width: `${(x.erros / maxRuns) * 100}%`, borderRadius: 0 }} />
              </div>
            </div>
            <div className={classes.num} style={{ width: 120, textAlign: "right" }}>
              {num(x.runs)}{x.erros ? ` · ${num(x.erros)} erro(s)` : ""}
            </div>
          </div>
        ))}
      </div>

      <div className={classes.card}>
        <div className={classes.cardTitle}>Erros mais frequentes (7 dias)</div>
        <div className={classes.cardSub}>
          Agrupados pela mensagem. Quando aparece em vários clientes, é bug nosso — não erro de configuração de um.
        </div>
        {errosComuns.length === 0 && <div className={classes.empty}>Nenhum erro no período.</div>}
        {errosComuns.map((e, i) => (
          <div key={`${e.mensagem}-${i}`} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
            <div className={classes.grow}>
              <div className={classes.strong}>{e.mensagem}</div>
              <div className={classes.muted}>
                {e.type} · {num(e.clientes)} cliente(s) afetado(s) · último {dateTime(e.ultimo)}
              </div>
            </div>
            <div className={classes.num}>
              {e.clientes > 1
                ? <span className={`${classes.pill} ${classes.bad}`}>{num(e.total)}</span>
                : num(e.total)}
            </div>
          </div>
        ))}
      </div>

      <div className={classes.cols}>
        <div className={classes.card}>
          <div className={classes.cardTitle}>API pública (7 dias)</div>
          <div className={classes.cardSub}>
            {num(apiStats.erros4xx)} erro(s) 4xx · {num(apiStats.erros5xx)} erro(s) 5xx · pico de {num(apiStats.latenciaMax)}ms
          </div>
          {apiStats.rotas.length === 0 && <div className={classes.empty}>Sem chamadas no período.</div>}
          {apiStats.rotas.map((r, i) => (
            <div key={r.rota} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
              <div className={classes.grow}>
                <div className={classes.strong}>{r.rota}</div>
                <div className={classes.muted}>
                  {r.latenciaMedia}ms em média{r.erros ? ` · ${num(r.erros)} com erro` : ""}
                </div>
              </div>
              <div className={classes.num}>{num(r.total)}</div>
            </div>
          ))}
        </div>

        <div>
          <div className={classes.card}>
            <div className={classes.cardTitle}>Webhooks de saída (7 dias)</div>
            <div className={classes.cardSub}>
              {num(webhooks.total7)} entrega(s), {num(webhooks.falhas7)} falha(s).
            </div>
            {webhooks.falhando.length === 0 && <div className={classes.empty}>Nenhum endpoint falhando.</div>}
            {webhooks.falhando.map((w, i) => (
              <div key={w.endpointId} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
                <div className={classes.grow}>
                  <div className={classes.strong}>Endpoint #{w.endpointId} · {w.email || "—"}</div>
                  <div className={classes.muted}>HTTP {w.statusCode || "—"} · {w.erro || "sem detalhe"}</div>
                </div>
                <div className={classes.num}>{num(w.falhas)}</div>
              </div>
            ))}
          </div>

          <div className={classes.card}>
            <div className={classes.cardTitle}>SMS — triagem de fraude (30 dias)</div>
            <div className={classes.cardSub}>
              Bloqueio demais é falso positivo incomodando cliente; de menos é golpe saindo pelo nosso número.
            </div>
            <div className={`${classes.row} ${classes.rowFirst}`}>
              <div className={classes.grow}><div className={classes.strong}>Enviados</div></div>
              <div className={classes.num}>{num(sms.total30)}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.grow}><div className={classes.strong}>Bloqueados pela IA</div></div>
              <div className={classes.num}>{num(sms.bloqueados30)}</div>
            </div>
            {sms.motivos.map(m => (
              <div key={m.categoria} className={classes.row}>
                <div className={classes.grow}><div className={classes.muted}>{m.categoria}</div></div>
                <div className={classes.num}>{num(m.total)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Shell>
  );
};

export default Operations;
